export const SUB_ITEM_CLASSNAME = 'sub-item';
export const EXPANDABLE_ITEM_CLASSNAME = 'expandable-item';
export const HOVERED_ROW_CLASSNAME = 'hovered-row';
